// itinerarySlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Url } from "./url";

export const fetchHomePageData = createAsyncThunk(
  "homePageData/fetchHomePageData",
  async (rejectWithValue) => {
    try {
      const response = await axios.get(
        `https://api.nilecabins.info/HomePage?NumberOfCruises=4`
      );
      return response.data; // Assuming the API response format is { data: [...] }
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const homePageDataSlice = createSlice({
  name: "homePageData",
  initialState: {
    homePageData: [],
    loading: false, // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHomePageData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchHomePageData.fulfilled, (state, action) => {
        state.loading = false;
        state.homePageData = action.payload;
      })
      .addCase(fetchHomePageData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default homePageDataSlice.reducer;
